'use strict';

var _objectSpread = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

var _objectWithoutProperties = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectWithoutProperties");

var modeToString = require('./mode-to-string');

var mtimeToObject = require('./mtime-to-object');
/**
 * @param {object} params
 * @returns {URLSearchParams}
 */


module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      arg = _ref.arg,
      searchParams = _ref.searchParams,
      hashAlg = _ref.hashAlg,
      mtime = _ref.mtime,
      mode = _ref.mode,
      options = _objectWithoutProperties(_ref, ["arg", "searchParams", "hashAlg", "mtime", "mode"]);

  if (searchParams) {
    options = _objectSpread({}, options, searchParams);
  }

  if (hashAlg) {
    options.hash = hashAlg;
  }

  if (mtime != null) {
    mtime = mtimeToObject(mtime);
    options.mtime = mtime.secs;
    options.mtimeNsecs = mtime.nsecs;
  }

  if (mode != null) {
    options.mode = modeToString(mode);
  }

  if (options.timeout && !isNaN(options.timeout)) {
    // server API expects timeouts as strings
    options.timeout = "".concat(options.timeout, "ms");
  }

  if (arg === undefined || arg === null) {
    arg = [];
  } else if (!Array.isArray(arg)) {
    arg = [arg];
  }

  var urlSearchParams = new URLSearchParams(options);
  arg.forEach(function (arg) {
    return urlSearchParams.append('arg', arg);
  });
  return urlSearchParams;
};